module.exports = __webpack_public_path__ + "img/MFT白皮书_36.1f9d5bb2.jpg";